import { differenceInCalendarDays } from 'date-fns'

import { CalculadoraDeValorPresenteBase } from '@/features/simulador/shared/domain/calculadora-de-valor-presente'
import type { IParcela } from '@/features/simulador/shared/types/calculadora-parcela.types'

export class CalculadoraDeValorPresenteSacocVParcelado extends CalculadoraDeValorPresenteBase {
  override calcularValorPresenteDasParcelas(
    parcelas: IParcela[],
    dataSimulacao: string,
    taxaDiaria: number,
    dataSaldoCondicaoPreco?: string,
  ) {
    return parcelas.map((parcela) => {
      const dataParcela = ['posConclusao', 'intermediariasPosConclusao'].includes(parcela.tipo)
        ? dataSaldoCondicaoPreco
        : parcela.data

      const quantidadeDias = differenceInCalendarDays(new Date(dataParcela!), new Date(dataSimulacao))
      const valorPresente = parcela.valor / (1 + taxaDiaria) ** quantidadeDias
      return { ...parcela, valorPresente }
    })
  }
}
